import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AweRequest } from '../models/awe-request';

@Injectable()
export class AweHttpService {
  private aweApproversUrl: string = this.environment.baseUrl + '/api/events/awe/approvers';
  private aweWorkflowUrl: string = this.environment.baseUrl + '/api/events/awe/workflow';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getAweApprovers(eventId: number, eventPartyId: number): Observable<any> {
    return this.http.get(`${this.aweApproversUrl}/${eventId}/${eventPartyId}`)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  executeAweWorkflow(aweRequest: AweRequest): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(this.aweWorkflowUrl, JSON.stringify(aweRequest.toJS()), options)
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/awe.http.service.ts